'use client';

import _defineProperty from "/codebuild/output/src2218/src/s3/01/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/codebuild/output/src2218/src/s3/01/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["title", "withOverlay", "overlayProps", "withCloseButton", "closeButtonProps", "children", "radius"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { jsxs, jsx } from 'react/jsx-runtime';
import 'react';
import { getDefaultZIndex } from '../../core/utils/get-default-z-index/get-default-z-index.mjs';
import '@mantine/hooks';
import 'clsx';
import '../../core/MantineProvider/Mantine.context.mjs';
import '../../core/MantineProvider/default-theme.mjs';
import '../../core/MantineProvider/MantineProvider.mjs';
import '../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs';
import { useProps } from '../../core/MantineProvider/use-props/use-props.mjs';
import '../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs';
import '../../core/Box/Box.mjs';
import { factory } from '../../core/factory/factory.mjs';
import '../../core/DirectionProvider/DirectionProvider.mjs';
import { ModalBody } from './ModalBody.mjs';
import { ModalCloseButton } from './ModalCloseButton.mjs';
import { ModalContent } from './ModalContent.mjs';
import { ModalHeader } from './ModalHeader.mjs';
import { ModalOverlay } from './ModalOverlay.mjs';
import { ModalRoot } from './ModalRoot.mjs';
import { ModalTitle } from './ModalTitle.mjs';
import classes from './Modal.module.css.mjs';
var defaultProps = {
  closeOnClickOutside: true,
  withinPortal: true,
  lockScroll: true,
  trapFocus: true,
  returnFocus: true,
  closeOnEscape: true,
  keepMounted: false,
  zIndex: getDefaultZIndex("modal"),
  transitionProps: {
    duration: 200,
    transition: "fade-down"
  },
  withOverlay: true,
  withCloseButton: true
};
var Modal = factory(function (_props, ref) {
  var _useProps = useProps("Modal", defaultProps, _props),
    title = _useProps.title,
    withOverlay = _useProps.withOverlay,
    overlayProps = _useProps.overlayProps,
    withCloseButton = _useProps.withCloseButton,
    closeButtonProps = _useProps.closeButtonProps,
    children = _useProps.children,
    radius = _useProps.radius,
    others = _objectWithoutProperties(_useProps, _excluded);
  var hasHeader = !!title || withCloseButton;
  return /* @__PURE__ */jsxs(ModalRoot, _objectSpread(_objectSpread({
    ref: ref,
    radius: radius
  }, others), {}, {
    children: [withOverlay && /* @__PURE__ */jsx(ModalOverlay, _objectSpread({}, overlayProps)), /* @__PURE__ */jsxs(ModalContent, {
      radius: radius,
      children: [hasHeader && /* @__PURE__ */jsxs(ModalHeader, {
        children: [title && /* @__PURE__ */jsx(ModalTitle, {
          children: title
        }), withCloseButton && /* @__PURE__ */jsx(ModalCloseButton, _objectSpread({}, closeButtonProps))]
      }), /* @__PURE__ */jsx(ModalBody, {
        children: children
      })]
    })]
  }));
});
Modal.classes = classes;
Modal.displayName = "@mantine/core/Modal";
Modal.Root = ModalRoot;
Modal.Overlay = ModalOverlay;
Modal.Content = ModalContent;
Modal.Body = ModalBody;
Modal.Header = ModalHeader;
Modal.Title = ModalTitle;
Modal.CloseButton = ModalCloseButton;
export { Modal };